import { addLastInSectionInfo } from '../getTransactions';
import { formatDateForSectionHeader } from '../formatting';
export const getActivitiesSectionedFlashlist = (activities, key) => {
    if (!activities?.length || !key) {
        return [];
    }
    let activeDate;
    const flashListData = [];
    activities.forEach((activity) => {
        let didAddNewSection = false;
        const dateToUseRaw = activity[key];
        const dateToUse = formatDateForSectionHeader(dateToUseRaw);
        if (!activeDate || dateToUse !== activeDate) {
            activeDate = dateToUse;
            addLastInSectionInfo(flashListData);
            flashListData.push({
                id: dateToUse,
                sectionTitle: dateToUse,
            });
            didAddNewSection = true;
        }
        if (!didAddNewSection) {
            flashListData.push(activity);
        }
        else {
            flashListData.push({ ...activity, isFirstInSection: true });
        }
    });
    addLastInSectionInfo(flashListData);
    return flashListData;
};
export const addFlashListSectionedDataToActivities = (activities) => {
    const length = activities?.length;
    if (!length) {
        return [];
    }
    return activities.map((item, index) => ({
        ...item,
        isFirstInSection: index === 0 ? true : undefined,
        isLastInSection: index === length - 1 ? true : undefined,
    }));
};
